import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IoIosCheckmarkCircle, IoIosCloseCircleOutline } from "react-icons/io";
import PrimaryButton from "../../utils/buttons/primaryButton";
import axiosInstance, { notifySuccess } from "../../../utility/axiosInstance";
import { serviceRequests } from "../../../utility/api";
import { useDispatch, useSelector } from "react-redux";
import { compareTwoDate, compareTwoDateIFG } from "../../../utility/utils";
import { toast } from "react-toastify";
import { fetchServicesSettingInfo } from "../../../redux/serviceThunk";

export const ServiceBookingCard = ({
  currentStepInfo,
  onUpdate,
  data,
  setData,
  setServiceStatus,
  setBookModal,
}) => {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [availableWorkingDays, setAvailableWorkingDays] = useState([]);
  const [rescheduleDate, setRescheduleDate] = useState("");
  const [rescheduleTime, setRescheduleTime] = useState("");
  const [availableWorkingTime, setAvailableWorkingTime] = useState([]);
  const [isReschedule, setIsReschedule] = useState(false);
  const [error, setError] = useState(null);
  const [allchecked, setAllChecked] = useState([]);
  const dispatch = useDispatch();
  const { serviceSettingInfo } = useSelector((state) => state?.services);
  useEffect(() => {
    if (!serviceSettingInfo) {
      dispatch(fetchServicesSettingInfo());
    }
  }, []);

  useEffect(() => {
    try {
      console.log(serviceSettingInfo);
      if (serviceSettingInfo?.serviceMonthSetting.length > 0) {
        const currentDate = new Date();
        const serviceMonthSetting =
          serviceSettingInfo?.serviceMonthSetting?.filter(
            ({ monthYearDate }) => {
              const myDate = new Date(monthYearDate);
              const currentMonthYear = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth()
              );
              const monthYearDateObj = new Date(
                myDate.getFullYear(),
                myDate.getMonth()
              );

              return monthYearDateObj >= currentMonthYear;
            }
          );
        const availableDays = [];

        serviceMonthSetting?.forEach(({ serviceDateSettings }) => {
          availableDays.push(...serviceDateSettings);
        });
        if (availableDays.length > 0) {
          const holidays = serviceSettingInfo?.holidays.map(({ date }) => date);
          setAvailableWorkingDays(
            availableDays.filter(
              ({ date }) =>
                compareTwoDateIFG(date, currentDate) && !holidays.includes(date)
            )
          );
        }
        // serviceMonthSetting.workingDetails
      }
    } catch (error) {
      console.log(error);
    }
  }, [serviceSettingInfo, data]);

  useEffect(() => {
    const setDropOffTimeSlot = () => {
      const { start, end } =
        serviceSettingInfo?.workingDetails?.workingTime ?? {};
      const allTime = [];

      if (start && end) {
        let startDate = new Date();
        let endDate = new Date();
        let [startHour, startMinute] = start.split(":").map(Number);
        let [endHour, endMinute] = end.split(":").map(Number);

        if (compareTwoDate(rescheduleDate, new Date())) {
          let currentTimeString = startDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });
          let [currentHour, currentMinute] = currentTimeString
            .split(":")
            .map(Number);

          if (currentMinute < 30) {
            currentMinute = currentMinute < 15 ? 15 : 30;
          } else {
            currentMinute = currentMinute < 45 ? 45 : 0;
            if (currentMinute === 0) currentHour++;
          }

          startDate.setHours(currentHour, currentMinute, 0, 0);
        } else {
          startDate.setHours(startHour, startMinute, 0, 0);
        }

        endDate.setHours(endHour, endMinute, 0, 0);

        while (startDate < endDate) {
          const timeSlot = startDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });
          allTime.push({ time: timeSlot, status: true });

          startDate = new Date(startDate.getTime() + 15 * 60 * 1000);
        }

        setAvailableWorkingTime(allTime);
      }
    };

    if (
      availableWorkingTime.length === 0 ||
      compareTwoDate(rescheduleDate, new Date())
    ) {
      setDropOffTimeSlot();
    }
  }, [serviceSettingInfo, rescheduleDate]);

  const {
    user: { lastName, email, phone, firstName } = {},
    _id,
    serviceRequest,
    requestedAt: {
      date,
      proposedDate,
      timeSlots,
      proposedTime,
      status: rescheduleStatus,
    } = {},
    status: serviceStatus,
    payment: { paymentStatus, paymentType } = {},
    bookingType,
  } = data || {};

  const brand = data?.car?.brand || "N/A";
  const model = data?.car?.model || "N/A";

  function handleChange(e) {
    if (e.target.checked) {
      setAllChecked([...allchecked, e.target.value]);
    } else {
      setAllChecked(allchecked.filter((item) => item !== e.target.value));
    }
  }

  const onSRReschedule = async () => {
    setLoading(true);
    try {
      if (!rescheduleDate) {
        return
      }      
      // return;
      const body = {
        proposedDate: rescheduleDate,
        rescheduleStatus: "rescheduleProposed",
      };
      if (rescheduleTime) {
        body.proposedTime = rescheduleTime;
      }
      const response = await axiosInstance.put(
        `${serviceRequests.updateServiceRequest}/${_id}`,
        body
      );

      if (response.status === 200) {
        notifySuccess(
          t("bookServices.serviceRequestTable.messages.requestUpdated")
        );
        setData((prevData) =>
          prevData.map((item) =>
            _id === item?._id
              ? {
                  ...item,
                  requestedAt: {
                    ...item.requestedAt,
                    proposedDate: rescheduleDate ?? "",
                    proposedTime: rescheduleTime ?? "",
                    status: "rescheduleProposed",
                  },
                }
              : item
          )
        );
      } else {
        notifySuccess(
          t("bookServices.serviceRequestTable.messages.errorUpdatingStatus")
        );
      }
    } catch (error) {
      console.log(error);
      notifySuccess(
        t("bookServices.serviceRequestTable.messages.errorUpdatingStatus")
      );
    } finally {
      setLoading(false);
    }
  };

  const onSRStatusChange = async (
    status = "accepted",
    serviceRequestStatus
  ) => {
    if (allchecked?.length === 0 && status == "accepted") {
      setError(t("bookServices.selectOne"));
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.put(
        `${serviceRequests.updateServiceRequest}/${_id}`,
        {
          status: status,
          serviceRequests: allchecked,
          serviceRequestStatus: serviceRequestStatus,
        }
      );

      if (response.status === 200) {
        notifySuccess(
          t("bookServices.serviceRequestTable.messages.requestUpdated")
        );
        if (status == "accepted") {
          setData((prevData) =>
            prevData.map((item) => (_id === item?._id ? response.data : item))
          );
        }
        setBookModal(false);
        if (status == "rejected") {
          setData((prevData) => prevData.filter((item) => _id !== item?._id));
        }
      }
    } catch (error) {
      setError(error.message || "Failed to update reschedule");
    } finally {
      setLoading(false);
      setIsReschedule(!isReschedule);
    }
  };

  return (
    <>
      <div className="rounded-lg p-6 min-w-[460px] max-w-[460px] mx-auto bg-[#EDEDEDED] min-h-[470px]">
        <div className="flex gap-6 mb-5">
          <span
            onClick={() => {
              setError(null);
              setCurrent(0);
            }}
            className={` ${
              current === 0 ? "underline" : ""
            } font-semibold text-gray-800 text-sm cursor-pointer`}
          >
            {t("bookServices.serviceBookingCard.details")}
          </span>
          <span
            onClick={() => {
              setError(null);
              setCurrent(1);
            }}
            className={` ${
              current === 1 ? "underline" : ""
            } font-semibold text-gray-800 text-sm  cursor-pointer`}
          >
            {t("bookServices.serviceBookingCard.serviceRequests")}
          </span>
        </div>
        {current === 0 ? (
          <div className="space-y-4 mb-4 p-3 bg-white rounded-lg shadow-md max-w-full">
            <div className="flex justify-between items-center border-b pb-2">
              <span className="font-semibold text-gray-800 text-sm">
                {t("bookServices.serviceBookingCard.fields.name")}:
              </span>
              <span className="text-gray-600 text-sm">
                {firstName + " " + lastName}
              </span>
            </div>

            <div className="flex justify-between items-center border-b pb-3">
              <span className="font-semibold text-gray-800 text-sm">
                {t("bookServices.serviceBookingCard.fields.email")}:
              </span>
              <span className="text-gray-600 text-sm">{email}</span>
            </div>

            {phone ? (
              <div className="flex justify-between items-center border-b pb-3">
                <span className="font-semibold text-gray-800 text-sm">
                  {t("bookServices.serviceBookingCard.fields.phone")}:
                </span>
                <span className="text-gray-600 text-sm">{phone}</span>
              </div>
            ) : null}

            <div className="flex justify-between items-center border-b pb-3">
              <span className="font-semibold text-gray-800 text-sm">
                {t("bookServices.serviceBookingCard.fields.model")}:
              </span>
              <span className="text-gray-600 text-sm">
                {brand} {model}
              </span>
            </div>

            <div className="flex justify-between items-center border-b pb-3">
              <span className="font-semibold text-gray-800 text-sm">
                {t("bookServices.serviceBookingCard.fields.appointmentDate")}:
              </span>
              <span className="text-gray-600 text-sm">
                {new Date(date).toLocaleDateString()}
              </span>
            </div>
            <div className="flex justify-between items-center border-b pb-3">
              <span className="font-semibold text-gray-800 text-sm">
                {t("bookServices.serviceBookingCard.fields.status")}:
              </span>
              <span className="text-gray-600 text-sm">{t(`usedCars.table.${serviceStatus}`)}</span>
            </div>
            {timeSlots ? (
              <div className="flex justify-between items-center border-b pb-3">
                <span className="font-semibold text-gray-800 text-sm">
                  {t("bookServices.serviceBookingCard.fields.time")}:
                </span>

                <span className="text-gray-600 text-sm">{timeSlots}</span>
              </div>
            ) : null}
            {proposedDate ? (
              <div className="flex justify-between items-center border-b pb-3">
                <span className="font-semibold text-gray-800 text-sm">
                  {t("bookServices.serviceBookingCard.fields.proposedDate")}:
                </span>
                <span className="text-gray-600 text-sm flex items-center gap-2">
                  {new Date(proposedDate).toLocaleDateString()}
                </span>
              </div>
            ) : null}
            {proposedTime ? (
              <div className="flex justify-between items-center border-b pb-3">
                <span className="font-semibold text-gray-800 text-sm">
                  {t("bookServices.serviceBookingCard.fields.proposedTime")}:
                </span>
                <span className="text-gray-600 text-sm flex items-center gap-2">
                  {proposedTime}
                </span>
              </div>
            ) : null}
            {proposedDate ? (
              <div className="flex justify-between items-center border-b pb-3">
                <span className="font-semibold text-gray-800 text-sm">
                  {t("bookServices.serviceBookingCard.fields.proposedStatus")}:
                </span>
                <span className="text-gray-600 text-sm flex items-center gap-2">
                  {rescheduleStatus === "rescheduleConfirmed" ? (
                    <span className="text-green-600">
                      {t("bookServices.closeCard.status.confirmed")}
                    </span>
                  ) : rescheduleStatus === "rescheduleRejected" ? (
                    <span className="text-yellow-600">
                      {t("bookServices.closeCard.status.rejected")}
                    </span>
                  ) : (
                    <span className="text-yellow-600">
                      {t("usedCars.table.pending")}
                    </span>
                  )}
                </span>
              </div>
            ) : null}

            {/* <div className="text-center mt-4">
                    <p className="text-gray-700 italic text-sm">{paymentStatus}</p>
                  </div> */}
            {paymentStatus === "pending" &&
            serviceStatus !== "rejected" &&
            availableWorkingDays.length > 0 ? (
              <div className="mt-0 p-4">
                <span>{t("bookServices.serviceBookingCard.selectDate")} </span>
                <div className="flex gap-1 justify-center items-center min-w-full">
                  <input
                    type="date"
                    value={rescheduleDate}
                    onChange={(e) => {
                      const newDateValue = e.target.value;

                      if (
                        !availableWorkingDays.find(({ date }) =>
                          compareTwoDate(date, newDateValue)
                        )
                      ) {
                        toast.warn(t("serviceSettings.dateNotAvailable"));
                        return;
                      }

                      setRescheduleDate(newDateValue);
                    }}
                    className="w-full border border-gray-300 rounded mt-2 h-12 mb-1"
                  />
                  {rescheduleDate && timeSlots ? (
                    <select
                      value={rescheduleTime}
                      onChange={(e) => {
                        setRescheduleTime(e.target.value);
                      }}
                      className="w-28 border border-gray-300 rounded mt-2 h-12 mb-1"
                    >
                      <option selected value="">
                        ---
                      </option>
                      {bookingType == "waiting"
                        ? availableWorkingDays
                            ?.find(({ date }) =>
                              compareTwoDate(date, rescheduleDate)
                            )
                            ?.timeSlots.map(({ time }) => (
                              <option key={time} value={time}>
                                {time}
                              </option>
                            ))
                        : availableWorkingTime.map(({ time }) => (
                            <option key={time} value={time}>
                              {time}
                            </option>
                          ))}
                    </select>
                  ) : null}
                  <PrimaryButton
                    type="button"
                    onClick={onSRReschedule}
                    disabled={loading}
                    loading={loading}
                    title={t(
                      "bookServices.serviceBookingCard.buttons.reschedule"
                    )}
                  />
                  {/* <PrimaryButton
                    type="button"
                    onClick={() => onSRStatusChange("rejected", "rejected")}
                    disabled={loading}
                    loading={loading}
                    className={`${
                      loading ? "bg-gray-500" : "bg-[#990000]"
                    } hover:bg-[#990000] text-white font-semibold p-0`}
                    title={"Reject"}
                  /> */}
                </div>
                {error && <p className="text-red-600 mt-2">{error}</p>}
              </div>
            ) : null}
          </div>
        ) : null}
        {current == 1 && (
          <div className="space-y-4 mb-4 p-3 bg-white rounded-lg shadow-md max-w-full ">
            <div className="flex justify-between items-center pb-3">
              <span className="font-semibold text-gray-800 text-sm  w-40">
                {t("bookServices.serviceBookingCard.fields.serviceName")}
              </span>
              <span className="font-semibold text-gray-800 text-sm  w-40">
                {t("bookServices.serviceBookingCard.fields.status")}
              </span>
              {/* <span className="font-semibold text-gray-800 text-sm"></span> */}
            </div>
            {serviceRequest.map(({ service: { serviceName }, status, _id }) => {
              return (
                <div
                  className="flex justify-between items-center border-b pb-3"
                  key={_id}
                >
                  <span className="text-gray-600 text-sm w-40">
                    {serviceName}
                  </span>
                  <span className="text-gray-600 text-sm  w-40">
                  {t(`usedCars.table.${status?.toLowerCase()}`)}
                   
                  </span>
                  {serviceStatus === "accepted" ||
                  serviceStatus === "completed" ||
                  data?.requestedAt.status === "rescheduleProposed" ||
                  serviceStatus === "rejected" ? null : (
                    <input
                      onChange={handleChange}
                      type="checkbox"
                      value={_id}
                      // defaultChecked={isAccepted}
                      // checked={isAccepted}
                    />
                  )}
                </div>
              );
            })}
            {serviceStatus === "accepted" ||
            serviceStatus === "completed" ||
            serviceStatus === "rejected" ? null : (
              <div className="flex gap-5 items-center pb-3 mt-auto ">
                <PrimaryButton
                  type="button"
                  onClick={() => onSRStatusChange("accepted", "accepted")}
                  disabled={loading}
                  loading={loading}
                  className={`${
                    loading ? "bg-gray-500" : "bg-[#990000]"
                  } hover:bg-[#990000] text-white font-semibold p-0`}
                  title={t("usedCars.table.accept")}
                />
                {/* <PrimaryButton
                type="button"
                onClick={() => onSRStatusChange("rejected", "rejected")}
                disabled={loading}
                loading={loading}
                className={`${
                  loading ? "bg-gray-500" : "bg-[#990000]"
                } hover:bg-[#990000] text-white font-semibold p-0`}
                 title={t("usedCars.table.reject")}
              /> */}
                {error && <p className="text-red-600 mt-2">{error}</p>}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ServiceBookingCard;
